export const API_POST = "API_POST";
export const API_GET = "API_GET";
export const NETWORK_STARTED = "NETWORK_STARTED";
export const NETWORK_ENDED = "NETWORK_ENDED";

export const networkStarted = () => ({type: NETWORK_STARTED});
export const networkEnded = () => ({type: NETWORK_ENDED});
